import React from 'react'
import NotificationCoverModel from '../../../../NotificationCoverModel'
import i18next from 'i18next'

const NewSubDepManagerAssignmentNotificationCover = ({ notification }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <NotificationCoverModel
      notification={notification}
      notifCoverContent={
        rtl
          ? 'تعيين مدير جديد للقسم الفرعى'
          : 'New manager has been assigned to your sub-department'
      }
    />
  )
}

export default NewSubDepManagerAssignmentNotificationCover
